import { plural } from '@/lib/plural';
export const STATUS_LABEL = {
    draft: 'Черновик',
    scheduled: 'Запланирована',
    sending: 'Идёт',
    sent: 'Отправлена',
    stopped: 'Остановлена',
    cancelled: 'Отменена',
};
export const LOCALE_NAME = {
    ru: 'русский',
    en: 'английский',
    hy: 'армянский',
    tr: 'турецкий',
};
const pad = (n) => String(n).padStart(2, '0');
/** «12.10, 18:00» in the viewer's time; the year only when it isn't this one. */
export function when(iso, now = new Date()) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return iso;
    const year = d.getFullYear() === now.getFullYear() ? '' : `.${d.getFullYear()}`;
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}${year}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
/** «Запланирована на 12.10, 18:00», «Идёт с 12.10, 14:05», «Отправлена 12.10, 18:40». */
export function statusLine(m, now = new Date()) {
    const at = (iso, prefix) => (iso ? `${prefix}${when(iso, now)}` : '');
    switch (m.status) {
        case 'scheduled':
            return `Запланирована${at(m.scheduled_at, ' на ')}`;
        case 'sending':
            return `Идёт${at(m.started_at, ' с ')}`;
        case 'sent':
            return `Отправлена${at(m.finished_at, ' ')}`;
        case 'stopped':
            return `Остановлена${at(m.finished_at, ' ')}`;
        default:
            return STATUS_LABEL[m.status];
    }
}
/** «Telegram, почта», «Telegram» or «Почта». */
export function channelsText(m) {
    if (m.channel_telegram && m.channel_email)
        return 'Telegram, почта';
    return m.channel_telegram ? 'Telegram' : 'Почта';
}
/** The list line after the status: channels and the gift. */
export function listRest(m) {
    return [channelsText(m), m.gift_id ? 'с подарком' : null].filter(Boolean).join(' · ');
}
export function listSub(m, now = new Date()) {
    return `${statusLine(m, now)} · ${listRest(m)}`;
}
const num = (n) => n.toLocaleString('ru-RU');
/** «12 400 получателей». */
export const recipients = (n) => `${num(n)} ${plural(n, 'получатель', 'получателя', 'получателей')}`;
const CHANNEL = { telegram: 'Telegram', email: 'почта' };
/** The audience count in lines: everyone, by language, by channel, who is left out and why. */
export function previewLines(p) {
    const byLanguage = Object.entries(p.by_language)
        .map(([l, n]) => `${l} ${num(n)}`)
        .join(' · ');
    const byChannel = Object.entries(p.by_channel)
        .map(([c, n]) => `${CHANNEL[c]} ${num(n)}`)
        .join(' · ');
    const reasons = [
        p.skipped_no_translation > 0 && `нет перевода — ${num(p.skipped_no_translation)}`,
        p.skipped_no_contact > 0 && `нет контакта — ${num(p.skipped_no_contact)}`,
        p.skipped_telegram_blocked > 0 && `заблокировали бота — ${num(p.skipped_telegram_blocked)}`,
    ].filter(Boolean);
    return {
        total: recipients(p.total),
        byLanguage,
        byChannel,
        skipped: reasons.length ? `Не получат: ${reasons.join(', ')}` : null,
        noGiftByEmail: p.warnings.includes('gift_not_sent_by_email'),
    };
}
/** A `datetime-local` value as ISO with the viewer's offset: «2026-10-12T18:00:00+05:00». */
export function scheduleIso(local) {
    const d = new Date(local);
    if (!local || Number.isNaN(d.getTime()))
        return null;
    const offset = -d.getTimezoneOffset();
    const abs = Math.abs(offset);
    const zone = `${offset >= 0 ? '+' : '-'}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:00${zone}`;
}
